import { HttpErrorResponse } from '@angular/common/http';
import { createAction, props } from '@ngrx/store';
import { Address } from '../../state';
import { CreateProjectData, OwnerData } from './eligible-funds.model';

export const SetFromUrl = createAction(
  '[EligibleFunds] Set From Url',
  props<{ payload: OwnerData }>()
);

export const CreateProject = createAction(
  '[EligibleFunds] Create Project',
  props<{ payload: CreateProjectData }>()
);

export const CreateProjectSuccess = createAction(
  '[EligibleFunds] Create Project Success',
  props<{ token: string }>()
);

export const HandleProjectErrors = createAction(
  '[EligibleFunds] Handle Project Errors',
  props<{ error: HttpErrorResponse }>()
);

export const CreateProjectFail = createAction(
  '[EligibleFunds] Create Project Fail',
  props<{ error: HttpErrorResponse }>()
);

export const DisplayError = createAction(
  '[EligibleFunds] Display Error',
  props<{ error: string }>()
);

export const MultipleAddressFound = createAction(
  '[EligibleFunds] Multiple Addresses Found',
  props<{ payload: Address[] }>()
);

export const SelectAddress = createAction(
  '[EligibleFunds] Select Address',
  props<{ payload: Address; callback: Function }>()
);

export const HandleSelectAddressErrors = createAction(
  '[EligibleFunds] Handle Select Address Errors',
  props<{ error: HttpErrorResponse }>()
);
